export const migrationTable = {
    traitRegistry: {
        onTraitEnter: 'onTraitBecomeActive',
        onTraitLeave: 'onTraitBecomeInactive',
        skeleton: 'childFromSkeleton',
        ownAspect: 'childFromAspectName',
        onSelected: 'onOptionWasSelected',
        // speakPattern: 'hearPattern'
        /* imageHeight: 'height',
        imageWidth: 'width',
        scale_imageHeight: 'scale_height',
        scale_imageWidth: 'scale_width' */
    },
    conditionRegistry: {},
    actionRegistry: {}
};
export const deletionTable = {
    traitRegistry: ['comment', 'commentType']
};
